import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SyncoInviteExpiredIcon = (props: IconProps) => (
  <Icon w="210px" h="208px" viewBox="0 0 210 208" {...props} fill="none">
    <ellipse
      opacity="0.38"
      cx="104.922"
      cy="104.31"
      rx="99.9219"
      ry="99.9762"
      fill="#D6D6D6"
    />
    <mask
      id="mask0_4037_115902"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="50"
      y="37"
      width="12"
      height="11"
    >
      <rect
        x="50.166"
        y="37.1431"
        width="11.1368"
        height="10.5238"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_4037_115902)">
      <path
        d="M78.0078 66.2388H46.7549C54.7892 66.2388 61.3026 59.7252 61.3027 51.6909C61.3027 43.6565 54.7893 37.1431 46.7549 37.1431H78.0078V66.2388Z"
        fill="#F5F5F5"
      />
    </g>
    <path
      d="M61.3027 37.1431H201.793C206.212 37.1431 209.793 40.7248 209.793 45.1431V61.3335C209.793 65.7518 206.212 69.3335 201.793 69.3335H69.3027C64.8845 69.3335 61.3027 65.7518 61.3027 61.3335V37.1431Z"
      fill="#F5F5F5"
    />
    <line
      x1="73.2021"
      y1="45.667"
      x2="197.894"
      y2="45.667"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="73.2021"
      y1="51.8574"
      x2="197.894"
      y2="51.8574"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="73.2021"
      y1="58.667"
      x2="102.613"
      y2="58.667"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <mask
      id="mask1_4037_115902"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="50"
      y="143"
      width="12"
      height="11"
    >
      <rect
        x="50.166"
        y="143"
        width="11.1368"
        height="10.5238"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask1_4037_115902)">
      <path
        d="M78.0078 172.096H46.7549C54.7892 172.096 61.3026 165.582 61.3027 157.548C61.3027 149.513 54.7893 143 46.7549 143H78.0078V172.096Z"
        fill="#F5F5F5"
      />
    </g>
    <path
      d="M61.3027 143H201.793C206.212 143 209.793 146.582 209.793 151V167.19C209.793 171.609 206.212 175.19 201.793 175.19H69.3027C64.8845 175.19 61.3027 171.609 61.3027 167.19V143Z"
      fill="#F5F5F5"
    />
    <line
      x1="73.2021"
      y1="151.524"
      x2="197.894"
      y2="151.524"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="73.2021"
      y1="157.714"
      x2="197.894"
      y2="157.714"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="73.2021"
      y1="164.524"
      x2="108.8"
      y2="164.524"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <mask
      id="mask2_4037_115902"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="90"
      width="12"
      height="11"
    >
      <rect
        x="0.668945"
        y="90.3809"
        width="11.1368"
        height="10.5238"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask2_4037_115902)">
      <path
        d="M28.5107 119.477H-2.74219C5.29216 119.477 11.8055 112.963 11.8057 104.929C11.8057 96.8943 5.29224 90.3809 -2.74219 90.3809H28.5107V119.477Z"
        fill="#F5F5F5"
      />
    </g>
    <path
      d="M11.8057 90.3809H152.296C156.715 90.3809 160.296 93.9626 160.296 98.3809V114.571C160.296 118.99 156.715 122.571 152.296 122.571H19.8057C15.3874 122.571 11.8057 118.99 11.8057 114.571V90.3809Z"
      fill="#F5F5F5"
    />
    <line
      x1="23.7051"
      y1="98.9048"
      x2="148.397"
      y2="98.9048"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="23.7051"
      y1="105.095"
      x2="148.397"
      y2="105.095"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="23.7051"
      y1="111.905"
      x2="106.325"
      y2="111.905"
      stroke="#EBEBEB"
      strokeWidth="4"
      strokeLinecap="round"
    />
    <ellipse
      cx="15.5183"
      cy="123.809"
      rx="7.42454"
      ry="7.42857"
      fill="#99CAFF"
    />
    <g clipPath="url(#clip0_4037_115902)">
      <path
        d="M11.5479 127.06H12.9915V122.726H11.5479V127.06ZM19.488 123.087C19.488 122.69 19.1632 122.365 18.7662 122.365H16.4888L16.8316 120.715L16.8425 120.599C16.8425 120.451 16.7811 120.314 16.6837 120.217L16.3011 119.837L13.9263 122.217C13.7927 122.347 13.7133 122.528 13.7133 122.726V126.337C13.7133 126.735 14.0382 127.06 14.4352 127.06H17.6834C17.983 127.06 18.2392 126.879 18.3475 126.619L19.4375 124.073C19.4699 123.99 19.488 123.904 19.488 123.81V123.087Z"
        fill="white"
      />
    </g>
    <rect
      x="141.117"
      y="17.3335"
      width="31.5543"
      height="11.1429"
      rx="5.57143"
      fill="#E5F2FF"
    />
    <ellipse
      cx="147.303"
      cy="22.905"
      rx="1.85613"
      ry="1.85714"
      fill="#99CAFF"
    />
    <ellipse
      cx="153.491"
      cy="22.905"
      rx="1.85613"
      ry="1.85714"
      fill="#99CAFF"
    />
    <ellipse
      cx="159.678"
      cy="22.905"
      rx="1.85614"
      ry="1.85714"
      fill="#99CAFF"
    />
    <ellipse
      cx="165.865"
      cy="22.905"
      rx="1.85613"
      ry="1.85714"
      fill="#99CAFF"
    />
    <mask
      id="mask3_4037_115902"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="11"
      y="28"
      width="41"
      height="41"
    >
      <ellipse
        cx="31.6044"
        cy="48.2856"
        rx="19.7988"
        ry="19.8095"
        fill="#E5F2FF"
      />
    </mask>
    <g mask="url(#mask3_4037_115902)">
      <g clipPath="url(#clip1_4037_115902)">
        <rect
          width="58.2649"
          height="123.385"
          transform="translate(2.18945 25.0801)"
          fill="#E5F2FF"
        />
        <g clipPath="url(#clip2_4037_115902)">
          <path
            d="M24.8014 57.9375C24.8014 57.9375 18.5756 62.1699 16.7807 80.3805C15.5222 93.1372 14.436 97.6205 14.436 97.6205L18.1053 97.6733C18.1053 97.6733 25.2783 79.8061 25.9274 71.8761C26.232 68.1323 24.8014 57.9441 24.8014 57.9441V57.9375Z"
            fill="white"
          />
          <path
            d="M38.2003 57.7725C38.2003 57.7725 45.4263 60.5853 47.0092 79.8655C48.0557 92.6354 49.1353 97.6205 49.1353 97.6205L45.466 97.6733C45.466 97.6733 38.293 79.8061 37.644 71.8761C37.3393 68.1323 38.2069 57.7725 38.2069 57.7725H38.2003Z"
            fill="white"
          />
          <path
            d="M29.6032 56.4123C27.2586 56.5576 24.6755 56.967 23.9536 59.41C23.4701 62.7378 25.0663 73.375 23.0462 84.2564C20.2048 99.575 20.8142 116.174 20.8142 116.174L43.2206 116.34C43.2206 116.34 43.5054 99.5816 41.2072 84.4215C39.6507 74.1607 40.9422 64.032 39.4917 59.4034C38.7301 56.967 35.0674 56.7293 33.8222 56.4123C32.3188 55.7851 31.5968 56.2869 29.6032 56.4123Z"
            fill="white"
          />
          <path
            d="M45.5917 42.0776C45.5917 49.8294 39.2864 56.1153 31.5107 56.1153C23.735 56.1153 17.4297 49.8294 17.4297 42.0776C17.4297 34.3259 23.735 28.04 31.5107 28.04C39.2864 28.04 45.5917 34.3259 45.5917 42.0776Z"
            fill="#323232"
          />
          <path
            d="M27.2518 47.9474C27.2518 47.9474 26.7219 45.0289 27.6624 43.2264C28.8413 40.9616 32.3583 39.7137 35.0672 42.1237C36.9548 43.8008 35.9613 48.2313 35.9613 48.2313L30.0534 45.7288L27.2518 47.9408V47.9474Z"
            fill="#323232"
          />
          <path
            d="M33.822 56.4124C33.822 56.4124 31.3449 57.7197 29.603 56.4124L29.9739 51.8828H33.4511L33.822 56.4124Z"
            fill="#29374F"
          />
          <path
            d="M27.9938 47.4392C27.9938 47.4392 27.497 47.1156 27.1063 47.6307C26.7221 48.1457 26.9804 50.0671 27.9408 50.0671C28.9012 50.0671 27.9872 47.4392 27.9872 47.4392H27.9938Z"
            fill="#29374F"
          />
          <path
            d="M35.458 47.4392C35.458 47.4392 35.9547 47.1156 36.3455 47.6307C36.7297 48.1457 36.478 50.0671 35.511 50.0671C34.544 50.0671 35.4646 47.4392 35.4646 47.4392H35.458Z"
            fill="#29374F"
          />
          <path
            d="M35.617 46.9042C35.617 44.745 33.8685 43.332 31.7093 43.332C29.5501 43.332 27.8016 44.745 27.8016 46.9042C27.8016 46.9042 27.6294 49.6575 27.6294 49.7962C27.6294 51.8497 30.1529 54.4512 31.7093 54.4512C33.5108 54.4512 35.7892 51.3479 35.7892 49.7962C35.7892 49.6641 35.617 46.9042 35.617 46.9042Z"
            fill="#2F3D5B"
          />
          <path
            d="M27.9077 51.2688C27.9077 51.2688 27.9607 51.2556 27.9872 51.2424L27.8944 51.0179C27.8944 51.0179 27.8613 51.0311 27.8481 51.0311C27.4176 51.1499 26.9672 50.8924 26.848 50.4566C26.7288 50.0275 26.9871 49.5785 27.4242 49.4596L27.3646 49.2285C26.8016 49.3804 26.4638 49.9614 26.6162 50.5161C26.7685 51.0773 27.3513 51.4074 27.9143 51.2622L27.9077 51.2688Z"
            fill="white"
          />
          <path
            d="M35.4716 51.2685C35.4716 51.2685 35.412 51.2487 35.3789 51.2355C35.4054 51.2421 35.4783 51.0176 35.4783 51.0176C35.4981 51.0176 35.518 51.0308 35.5312 51.0374C35.9618 51.1563 36.4121 50.8988 36.5314 50.463C36.6506 50.0338 36.3923 49.5848 35.9551 49.466L36.0147 49.2349C36.5777 49.3867 36.9089 49.9678 36.7632 50.5224C36.6108 51.0837 36.028 51.4138 35.465 51.2685H35.4716Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <mask
      id="mask4_4037_115902"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="162"
      y="85"
      width="40"
      height="41"
    >
      <ellipse
        cx="181.952"
        cy="105.238"
        rx="19.7988"
        ry="19.8095"
        fill="#FFFAE5"
      />
    </mask>
    <g mask="url(#mask4_4037_115902)">
      <g clipPath="url(#clip3_4037_115902)">
        <rect
          width="87.6803"
          height="120.555"
          transform="translate(116.333 82.5986)"
          fill="#FFFAE5"
        />
        <path
          d="M181.03 93.002C177.831 93.0328 173.848 94.734 174.315 100.006C174.642 103.7 175.532 110.022 177.959 110.218C179.033 110.305 182.714 108.963 182.714 108.963L183.022 113.376L189.928 111.554L187.217 105.833C187.217 105.833 191.575 92.9009 181.03 93.0048V93.002Z"
          fill="#FFEACC"
        />
        <path
          d="M175.4 95.1973L181.688 100.688C182.096 98.9645 183.414 99.0431 184.373 100.096C185.553 101.393 184.116 103.147 184.415 103.61C184.717 104.071 186.806 105.878 187.212 105.831C187.62 105.783 194.224 100.379 188.515 92.6709C185.883 89.1171 178.692 89.5269 175.397 95.1973H175.4Z"
          fill="#323232"
        />
        <path
          d="M178.538 87.2193C178.611 89.7542 180.233 91.2897 182.533 91.2251C184.829 91.1605 185.83 89.4735 185.76 86.9386C185.688 84.4038 184.423 82.5342 182.124 82.5988C179.825 82.6634 178.466 84.6817 178.538 87.2165V87.2193Z"
          fill="#323232"
        />
        <path
          d="M183.732 115.336C179.394 115.709 178.3 126.168 183.055 145.254L164.928 151.739L167.957 154.852C167.957 154.852 186.767 154.254 189.857 147.348C192.948 140.443 191.731 114.648 183.732 115.336Z"
          fill="white"
        />
        <path
          d="M181.078 111.069L203.121 105.648C203.121 105.648 207.599 119.661 196.503 120.315C185.41 120.972 181.08 111.069 181.08 111.069H181.078Z"
          fill="white"
        />
        <path
          d="M187.097 110.367C190.269 110.563 193.385 111.335 195.429 117.343C198.344 125.618 200.405 140.038 200.481 167.405L174.608 157.69C177.274 143.665 176.186 115.566 181.078 111.071C183.111 110.213 184.403 110.201 187.097 110.37V110.367Z"
          fill="white"
        />
        <path
          d="M188.596 116.338C184.244 116.349 183.165 127.171 187.919 146.256L172.997 151.284L172.821 155.857C172.821 155.857 191.631 155.784 194.722 148.878C197.812 141.973 193.637 116.329 188.596 116.341V116.338Z"
          fill="white"
        />
      </g>
    </g>
    <mask
      id="mask5_4037_115902"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="149"
      width="41"
      height="40"
    >
      <ellipse cx="28.5112" cy="169" rx="19.7988" ry="19.8095" fill="#FEEFEA" />
    </mask>
    <g mask="url(#mask5_4037_115902)">
      <g clipPath="url(#clip4_4037_115902)">
        <rect
          width="85.9832"
          height="176.022"
          transform="translate(-14.4805 147.493)"
          fill="#FEEFEA"
        />
        <path
          d="M31.2746 148.381C35.1949 148.528 39.6907 152.645 39.2661 157.15C38.8414 161.655 37.4351 169.324 34.4533 169.478C33.1332 169.548 28.6713 167.788 28.6713 167.788L28.142 173.159L19.7412 170.7L23.2554 163.815C23.2554 163.815 18.3565 147.895 31.2746 148.381Z"
          fill="#F7A283"
        />
        <path
          d="M33.2287 154.781C31.3547 157.433 31.1086 162.054 30.2069 157.731C29.7669 155.617 28.1452 155.666 26.9359 156.92C25.4465 158.462 27.1482 160.647 26.7635 161.203C26.3789 161.756 23.7571 163.885 23.2586 163.815C22.7601 163.744 20.3137 154.717 23.8741 150.194C27.7698 145.243 37.423 147.68 38.2169 152.842C37.4107 152.593 35.0843 152.163 33.2318 154.784L33.2287 154.781Z"
          fill="white"
        />
        <path
          d="M23.3505 169.419C19.464 169.662 15.876 173.709 13.3711 181.04C11.4479 194.259 7.7583 240.629 7.7583 240.629H42.9861C42.9861 240.629 38.1857 177.565 31.2374 172.206C28.4771 169.951 26.6523 169.217 23.3474 169.419H23.3505Z"
          fill="#282644"
        />
        <path
          d="M23.3201 176.167C28.4498 177.642 27.9175 187.281 17.6858 208.996L32.8748 231.143L26.7666 236.579C26.7666 236.579 9.34346 221.151 7.25712 212.154C5.17077 203.157 13.8577 173.451 23.317 176.167H23.3201Z"
          fill="#282644"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4037_115902">
        <rect
          width="8.66196"
          height="8.66666"
          fill="white"
          transform="translate(11.187 119.476)"
        />
      </clipPath>
      <clipPath id="clip1_4037_115902">
        <rect
          width="58.2649"
          height="123.385"
          fill="white"
          transform="translate(2.18945 25.0801)"
        />
      </clipPath>
      <clipPath id="clip2_4037_115902">
        <rect
          width="34.6992"
          height="120.317"
          fill="white"
          transform="translate(14.436 28.04)"
        />
      </clipPath>
      <clipPath id="clip3_4037_115902">
        <rect
          width="87.6803"
          height="120.555"
          fill="white"
          transform="translate(116.333 82.5986)"
        />
      </clipPath>
      <clipPath id="clip4_4037_115902">
        <rect
          width="85.9832"
          height="176.022"
          fill="white"
          transform="translate(-14.4805 147.493)"
        />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(SyncoInviteExpiredIcon);
